import { httpsCallable } from "firebase/functions";
import { ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { functions, storage } from '@/firebase/config.js';


export const getSubtopics = async(revId) => {
    // return await (await getDocs(collection(db, reviewersColName, 'caap', 'subtopics'))).docs;
    const getAllSubtopics = httpsCallable(functions, 'getAllSubtopics');
    return await getAllSubtopics({ revId })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

/**
 * get all list of questionnaires
 * @returns {*}
 */
export const getQuestionnaires = async(revId) => {
    const getQuestionnaires = httpsCallable(functions, 'getQuestionnaires');
    return await getQuestionnaires({ revId })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

/**
 * add new questionnaire or subtopic to questionnaires
 * @param {*} subtopic 
 * @returns 
 */
export const addQuestionnaire = async(revId, subtopic) => {
    const addQuestionnaire = httpsCallable(functions, 'addQuestionnaire');
    return await addQuestionnaire({ revId, subtopicId: subtopic.id, subtopicName: subtopic.name })
        .then((result) => {
            return result;
        })
        .catch((err) => {
            return err;
        });
}

export const isHtmlEmpty = (html) => {
    if (!html) return true;
  
    // Create a temporary DOM element to parse the HTML
    const div = document.createElement('div');
    div.innerHTML = html;
  
    // Get the text content (this removes all HTML tags)
    const text = div.textContent || div.innerText || '';
  
    // Remove all whitespace, non-breaking spaces, and check length
    return text.replace(/\u00a0|\s/g, '').length === 0;
  }

/**
 * Add new question for a subtopic
 * @param {*} questionForm 
 * @returns 
 */
// export const addQuestion = async (revId, tags, questionForm, imageFile) => {

//     // Validate question content
//     const hasTextQuestion = questionForm.form.question && questionForm.form.question.trim() !== '';
//     const hasHtmlQuestion = questionForm.form.questionHtml && !isHtmlEmpty(questionForm.form.questionHtml);

//     if (!hasTextQuestion && !hasHtmlQuestion) {
//         return {
//             data: {
//             isError: true,
//             error: {
//                 message: 'Please fill out the question.'
//             }
//             }
//         };
//     }

//     // Count valid choices (either text or rich HTML)
//     const validChoices = questionForm.form.choices.filter(choice =>
//     choice.choice?.trim() || !isHtmlEmpty(choice.choiceHtml)
//     );

//     if (validChoices.length < 2) {
//         return {
//             data: {
//             isError: true,
//             error: {
//                 message: 'Please add at least 2 choices.'
//             }
//             }
//         };
//     }


//     // Upload the main image (legacy support, used only in CAAP Knowledge section).
//     let storageRefPath = `images/questions/${revId}/${questionForm.subtopic}/${questionForm.form.id}`;
//     if (questionForm.form.hasImage && imageFile) {
//       const uploadRes = await uploadImage(storageRefPath, imageFile);
//       if (uploadRes.isError) return uploadRes;
//       questionForm.form.imageUrl = uploadRes.url;
//       questionForm.form.storageRefPath = storageRefPath;
//     }
  
//     // Check if the questionHtml contains base64 images
//     if (questionForm.form.questionHtml) {
  
//       // Regular expression to match <img> tags that use base64 data URLs
//       const base64ImgRegex = /<img[^>]+src="(data:image\/[^;]+;base64[^"]+)"[^>]*>/g;
//       let imgIndex = 0; // Still used to ensure unique placeholders
  
//       // Step 1: Replace base64 src with placeholders and store base64 strings temporarily
//       const updatedHtml = questionForm.form.questionHtml.replace(base64ImgRegex, (fullTag, base64Img) => {
//         const placeholder = `__UPLOAD_PLACEHOLDER__${imgIndex}__`;
//         questionForm.form[`__imgBase64__${imgIndex}`] = base64Img;
//         imgIndex++;
//         return fullTag.replace(base64Img, placeholder);
//       });
  
//       // Step 2: Upload each base64 image and replace placeholders with actual URLs
//       let finalHtml = updatedHtml;
//       for (let i = 0; i < imgIndex; i++) {
//         const base64Img = questionForm.form[`__imgBase64__${i}`];
  
//         // Use a timestamp for a unique image path (plus index just for clarity/debugging)
//         const timestamp = Date.now();
//         const htmlImgPath = `images/questionsHtml/${revId}/${questionForm.subtopic}/${questionForm.form.id}-${timestamp}-${i}`;
  
//         console.log('Uploading base64 image:', base64Img.slice(0, 50));
//         const uploadRes = await uploadBase64Image(htmlImgPath, base64Img);
//         if (uploadRes.isError) return uploadRes;
  
//         const placeholder = `__UPLOAD_PLACEHOLDER__${i}__`;
//         finalHtml = finalHtml.replace(placeholder, uploadRes.url);
//         delete questionForm.form[`__imgBase64__${i}`];
//       }
  
//       // Apply final processed HTML with all uploaded image URLs
//       questionForm.form.questionHtml = finalHtml;
//     }

//     // Check if the study contains base64 images
//     if (questionForm.form.study) {
  
//         // Regular expression to match <img> tags that use base64 data URLs
//         const base64ImgRegex = /<img[^>]+src="(data:image\/[^;]+;base64[^"]+)"[^>]*>/g;
//         let imgIndex = 0; // Still used to ensure unique placeholders
    
//         // Step 1: Replace base64 src with placeholders and store base64 strings temporarily
//         const updatedHtml = questionForm.form.study.replace(base64ImgRegex, (fullTag, base64Img) => {
//           const placeholder = `__UPLOAD_PLACEHOLDER__${imgIndex}__`;
//           questionForm.form[`__imgBase64__${imgIndex}`] = base64Img;
//           imgIndex++;
//           return fullTag.replace(base64Img, placeholder);
//         });
    
//         // Step 2: Upload each base64 image and replace placeholders with actual URLs
//         let finalHtml = updatedHtml;
//         for (let i = 0; i < imgIndex; i++) {
//           const base64Img = questionForm.form[`__imgBase64__${i}`];
    
//           // Use a timestamp for a unique image path (plus index just for clarity/debugging)
//           const timestamp = Date.now();
//           const htmlImgPath = `images/questionsHtml/${revId}/${questionForm.subtopic}/${questionForm.form.id}-${timestamp}-${i}`;
    
//           console.log('Uploading base64 image:', base64Img.slice(0, 50));
//           const uploadRes = await uploadBase64Image(htmlImgPath, base64Img);
//           if (uploadRes.isError) return uploadRes;
    
//           const placeholder = `__UPLOAD_PLACEHOLDER__${i}__`;
//           finalHtml = finalHtml.replace(placeholder, uploadRes.url);
//           delete questionForm.form[`__imgBase64__${i}`];
//         }
    
//         // Apply final processed HTML with all uploaded image URLs
//         questionForm.form.study = finalHtml;
//     }
  
//     // Final call to Cloud Function to save the question
//     const addQuestion = httpsCallable(functions, 'addQuestion');
//     return await addQuestion({ ...questionForm, revId, tags })
//       .then((result) => {

//         if (result.data.isError) {
//             if (questionForm.form.hasImage && imageFile) {
//                 deleteImage(storageRefPath); // Cleanup if error
//             }
//         }
//         return result;
//       })
//       .catch((err) => {
//         if (result.data.isError) {
//             if (questionForm.form.hasImage && imageFile) {
//                 deleteImage(storageRefPath); // Cleanup if error
//             }
//         }
//         return err;
//       });
//   };

export const addQuestion = async (revId, tags, questionForm, imageFile) => {

    // Helper to process base64 images in HTML content
    const processHtmlWithBase64Images = async (html, fieldKey) => {
      const base64ImgRegex = /<img[^>]+src="(data:image\/[^;]+;base64[^"]+)"[^>]*>/g;
      let imgIndex = 0;
      const updatedHtml = html.replace(base64ImgRegex, (fullTag, base64Img) => {
        const placeholder = `__UPLOAD_PLACEHOLDER__${fieldKey}_${imgIndex}__`;
        questionForm.form[`__imgBase64__${fieldKey}_${imgIndex}`] = base64Img;
        imgIndex++;
        return fullTag.replace(base64Img, placeholder);
      });
  
      let finalHtml = updatedHtml;
      for (let i = 0; i < imgIndex; i++) {
        const base64Img = questionForm.form[`__imgBase64__${fieldKey}_${i}`];
        const timestamp = Date.now();
        const htmlImgPath = `images/questionsHtml/${revId}/${questionForm.subtopic}/${questionForm.form.id}-${timestamp}-${i}`;
  
        console.log(`Uploading base64 image [${fieldKey}]:`, base64Img.slice(0, 50));
        const uploadRes = await uploadBase64Image(htmlImgPath, base64Img);
        if (uploadRes.isError) return uploadRes;
  
        const placeholder = `__UPLOAD_PLACEHOLDER__${fieldKey}_${i}__`;
        finalHtml = finalHtml.replace(placeholder, uploadRes.url);
        delete questionForm.form[`__imgBase64__${fieldKey}_${i}`];
      }
  
      return finalHtml;
    };
  
    // ✅ Step 1: Validate question content
    const hasTextQuestion = questionForm.form.question && questionForm.form.question.trim() !== '';
    const hasHtmlQuestion = questionForm.form.questionHtml && !isHtmlEmpty(questionForm.form.questionHtml);
    const hasStudy = questionForm.form.study && !isHtmlEmpty(questionForm.form.study);
  
    if (!hasTextQuestion && !hasHtmlQuestion && !hasStudy) {
      return {
        data: {
          isError: true,
          error: { message: 'Please fill out the question and study.' }
        }
      };
    }

    if (hasTextQuestion || hasHtmlQuestion) {

      const validChoices = questionForm.form.choices.filter(choice =>
        choice.choice?.trim() || !isHtmlEmpty(choice.choiceHtml)
      );
      if (validChoices.length < 2) {
        return {
          data: {
            isError: true,
            error: { message: 'Please add at least 2 choices.' }
          }
        };
      }
      
    }
  
    // ✅ Step 2: Upload legacy image if needed
    let storageRefPath = `images/questions/${revId}/${questionForm.subtopic}/${questionForm.form.id}`;
    if (questionForm.form.hasImage && imageFile) {
      const uploadRes = await uploadImage(storageRefPath, imageFile);
      if (uploadRes.isError) return uploadRes;
      questionForm.form.imageUrl = uploadRes.url;
      questionForm.form.storageRefPath = storageRefPath;
    }
  
    // ✅ Step 3: Process questionHtml
    if (questionForm.form.questionHtml) {
      const updatedHtml = await processHtmlWithBase64Images(questionForm.form.questionHtml, 'questionHtml');
      if (updatedHtml.isError) return updatedHtml;
      questionForm.form.questionHtml = updatedHtml;
    }
  
    // ✅ Step 4: Process study
    if (questionForm.form.study) {
      const updatedHtml = await processHtmlWithBase64Images(questionForm.form.study, 'study');
      if (updatedHtml.isError) return updatedHtml;
      questionForm.form.study = updatedHtml;
    }
  
    // ✅ Step 5: Save to Firestore via Cloud Function
    const addQuestion = httpsCallable(functions, 'addQuestion');
  
    try {
      const result = await addQuestion({ ...questionForm, revId, tags });
  
      if (result.data.isError && questionForm.form.hasImage && imageFile) {
        await deleteImage(storageRefPath);
      }
  
      return result;
    } catch (err) {
      if (questionForm.form.hasImage && imageFile) {
        await deleteImage(storageRefPath);
      }
      return { data: { isError: true, error: { message: 'Unexpected error occurred.' } } };
    }
};
  


/**
 * Update the question
 * @param {*} questionForm 
 * @returns 
 */
// export const updateQuestion = async(revId, tags, questionForm, imageFile) => {


//      // Check if the questionHtml contains base64 images
//      if (questionForm.form.questionHtml) {

//         // Regular expression to match <img> tags that use base64 data URLs
//         const base64ImgRegex = /<img[^>]+src="(data:image\/[^;]+;base64[^"]+)"[^>]*>/g;
//         let imgIndex = 0; // Counter to uniquely identify each base64 image
//         let match;

//         /**
//          * Step 1: Replace all base64 image `src` values in questionHtml with temporary placeholders
//          * like __UPLOAD_PLACEHOLDER__0__, __UPLOAD_PLACEHOLDER__1__, etc.
//          * Also, temporarily store each base64 string in the form using a dynamic key.
//          * This prepares the HTML for later replacement once the upload is complete.
//          */
//         const updatedHtml = questionForm.form.questionHtml.replace(base64ImgRegex, (fullTag, base64Img) => {
//             const placeholder = `__UPLOAD_PLACEHOLDER__${imgIndex}__`;
//             questionForm.form[`__imgBase64__${imgIndex}`] = base64Img;
//             imgIndex++;
//             return fullTag.replace(base64Img, placeholder);
//         });

//         /**
//          * Step 2: For each extracted base64 image:
//          * - Upload it to Firebase Storage.
//          * - Replace the corresponding placeholder in questionHtml with the uploaded image's URL.
//          * - Remove the temporary base64 entry from the form to clean up the payload.
//          */
//         for (let i = 0; i < imgIndex; i++) {
//             const base64Img = questionForm.form[`__imgBase64__${i}`];

//             // Define a unique Firebase Storage path for each uploaded image
//             const htmlImgPath = `images/questionsHtml/${revId}/${questionForm.subtopic}/${questionForm.form.id}-${i}`;

//             // Upload the base64 image to the defined storage path
//             console.log('Uploading base64 image:', base64Img.slice(0, 50));

//             const uploadRes = await uploadBase64Image(htmlImgPath, base64Img);
//             if (uploadRes.isError) return uploadRes;

//             // Replace the placeholder in the HTML with the uploaded image's URL
//             const placeholder = `__UPLOAD_PLACEHOLDER__${i}__`;
//             questionForm.form.questionHtml = updatedHtml.replace(placeholder, uploadRes.url);

//             // Remove the temporary base64 image data from the form
//             delete questionForm.form[`__imgBase64__${i}`];
//         }
//     }


//     const updateQuestion = httpsCallable(functions, 'updateQuestion');
//     return await updateQuestion({...questionForm, revId, tags })
//         .then(async(result) => {

//             // check if there is no error, then upload or delete image if needed
//             // and update the question information again!!!! (inefficient: need to refactor this code!)
//             if (!result.data.isError) {
//                 let storageRefPath = `images/questions/${revId}/${questionForm.subtopic}/${questionForm.form.id}`;
//                 // upload the image if has image and image file
//                 if (questionForm.form.hasImage && imageFile) {
//                     const uploadRes = await uploadImage(storageRefPath, imageFile);
//                     if (uploadRes.isError) { return uploadRes; }
//                     questionForm.form.imageUrl = uploadRes.url;
//                     questionForm.form.storageRefPath = storageRefPath;
//                     // this shoud work because it already work at first call
//                     await updateQuestion({...questionForm, revId, tags });
//                 }

//                 // remove the image if has image set to false but storage ref path has value value
//                 if (!questionForm.form.hasImage && questionForm.form.storageRefPath && questionForm.form.storageRefPath != '') {
//                     // delete the image
//                     deleteImage(storageRefPath);
//                     questionForm.form.storageRefPath = '';
//                     await updateQuestion({...questionForm, revId, tags });
//                 }
//             }

//             return result;
//         })
//         .catch((err) => {
//             return err;
//         });
// }
// export const updateQuestion = async (revId, tags, questionForm, imageFile, uploadImageUrls) => {

//     // Helper to process base64 images in any HTML field (e.g., questionHtml or study)
//     const processHtmlWithBase64Images = async (html, fieldKey) => {
//       const base64ImgRegex = /<img[^>]+src="(data:image\/[^;]+;base64[^"]+)"[^>]*>/g;
//       let imgIndex = 0;
  
//       const updatedHtml = html.replace(base64ImgRegex, (fullTag, base64Img) => {
//         const placeholder = `__UPLOAD_PLACEHOLDER__${fieldKey}_${imgIndex}__`;
//         questionForm.form[`__imgBase64__${fieldKey}_${imgIndex}`] = base64Img;
//         imgIndex++;
//         return fullTag.replace(base64Img, placeholder);
//       });
  
//       let finalHtml = updatedHtml;
//       for (let i = 0; i < imgIndex; i++) {
//         const base64Img = questionForm.form[`__imgBase64__${fieldKey}_${i}`];
//         const timestamp = Date.now();
//         const htmlImgPath = `images/questionsHtml/${revId}/${questionForm.subtopic}/${questionForm.form.id}-${timestamp}-${i}`;
  
//         console.log(`Uploading base64 image [${fieldKey}]:`, base64Img.slice(0, 50));
//         const uploadRes = await uploadBase64Image(htmlImgPath, base64Img);
//         if (uploadRes.isError) return uploadRes;
  
//         const placeholder = `__UPLOAD_PLACEHOLDER__${fieldKey}_${i}__`;
//         finalHtml = finalHtml.replace(placeholder, uploadRes.url);
//         delete questionForm.form[`__imgBase64__${fieldKey}_${i}`];
//       }
  
//       return finalHtml;
//     };
  
//     // ✅ Step 1: Validate content
//     const hasTextQuestion = questionForm.form.question?.trim() !== '';
//     const hasHtmlQuestion = questionForm.form.questionHtml && !isHtmlEmpty(questionForm.form.questionHtml);
  
//     if (!hasTextQuestion && !hasHtmlQuestion) {
//       return {
//         data: {
//           isError: true,
//           error: { message: 'Please fill out the question.' }
//         }
//       };
//     }
  
//     const validChoices = questionForm.form.choices.filter(choice =>
//       choice.choice?.trim() || !isHtmlEmpty(choice.choiceHtml)
//     );
  
//     if (validChoices.length < 2) {
//       return {
//         data: {
//           isError: true,
//           error: { message: 'Please add at least 2 choices.' }
//         }
//       };
//     }
  
//     // ✅ Step 2: Process `questionHtml`
//     if (questionForm.form.questionHtml) {
//       const processedHtml = await processHtmlWithBase64Images(questionForm.form.questionHtml, 'questionHtml');
//       if (processedHtml.isError) return processedHtml;
//       questionForm.form.questionHtml = processedHtml;
//     }
  
//     // ✅ Step 3: Process `study` field
//     if (questionForm.form.study) {
//       const processedHtml = await processHtmlWithBase64Images(questionForm.form.study, 'study');
//       if (processedHtml.isError) return processedHtml;
//       questionForm.form.study = processedHtml;
//     }
  
//     // ✅ Step 4: Handle legacy image file upload
//     const storageRefPath = `images/questions/${revId}/${questionForm.subtopic}/${questionForm.form.id}`;
//     if (questionForm.form.hasImage && imageFile) {
//       const uploadRes = await uploadImage(storageRefPath, imageFile);
//       if (uploadRes.isError) return uploadRes;
  
//       questionForm.form.imageUrl = uploadRes.url;
//       questionForm.form.storageRefPath = storageRefPath;
//     }
  
//     // ✅ Step 5: Delete legacy image if needed
//     if (!questionForm.form.hasImage && questionForm.form.storageRefPath) {
//       await deleteImage(storageRefPath);
//       questionForm.form.storageRefPath = '';
//     }
  
//     // ✅ Step 6: Call the Cloud Function
//     const updateQuestion = httpsCallable(functions, 'updateQuestion');
  
//     try {
//         const result = await updateQuestion({ ...questionForm, revId, tags });

//         // add code here where it will check if the urls inside uploadImageUrls array is not found already in questionForm.form.questionHtml and questionForm.form.study
//         // if not found, delete the image/s in the storage
//         // make sure that this is not a blocking code it will just run background.

//         return result;
//     } catch (err) {
//       return {
//         data: {
//           isError: true,
//           error: { message: 'Unexpected error occurred while updating the question.' }
//         }
//       };
//     }
//   };

export const updateQuestion = async (revId, tags, questionForm, imageFile, uploadImageUrls) => {

    // Helper to process base64 images in any HTML field
    const processHtmlWithBase64Images = async (html, fieldKey) => {
      const base64ImgRegex = /<img[^>]+src="(data:image\/[^;]+;base64[^"]+)"[^>]*>/g;
      let imgIndex = 0;
  
      const updatedHtml = html.replace(base64ImgRegex, (fullTag, base64Img) => {
        const placeholder = `__UPLOAD_PLACEHOLDER__${fieldKey}_${imgIndex}__`;
        questionForm.form[`__imgBase64__${fieldKey}_${imgIndex}`] = base64Img;
        imgIndex++;
        return fullTag.replace(base64Img, placeholder);
      });
  
      let finalHtml = updatedHtml;
      for (let i = 0; i < imgIndex; i++) {
        const base64Img = questionForm.form[`__imgBase64__${fieldKey}_${i}`];
        const timestamp = Date.now();
        const htmlImgPath = `images/questionsHtml/${revId}/${questionForm.subtopic}/${questionForm.form.id}-${timestamp}-${i}`;
  
        const uploadRes = await uploadBase64Image(htmlImgPath, base64Img);
        if (uploadRes.isError) return uploadRes;
  
        const placeholder = `__UPLOAD_PLACEHOLDER__${fieldKey}_${i}__`;
        finalHtml = finalHtml.replace(placeholder, uploadRes.url);
        delete questionForm.form[`__imgBase64__${fieldKey}_${i}`];
      }
  
      return finalHtml;
    };
  
    // ✅ Step 1: Validate content
    const hasTextQuestion = questionForm.form.question?.trim() !== '';
    const hasHtmlQuestion = questionForm.form.questionHtml && !isHtmlEmpty(questionForm.form.questionHtml);
    const hasStudy = questionForm.form.study && !isHtmlEmpty(questionForm.form.study);

     if (!hasTextQuestion && !hasHtmlQuestion && !hasStudy) {
      return {
        data: {
          isError: true,
          error: { message: 'Please fill out the question and study.' }
        }
      };
    }

    if (hasTextQuestion || hasHtmlQuestion) {

      const validChoices = questionForm.form.choices.filter(choice =>
        choice.choice?.trim() || !isHtmlEmpty(choice.choiceHtml)
      );
      if (validChoices.length < 2) {
        return {
          data: {
            isError: true,
            error: { message: 'Please add at least 2 choices.' }
          }
        };
      }
      
    }
  
  
    // ✅ Step 2: Process HTML fields
    if (questionForm.form.questionHtml) {
      const processedHtml = await processHtmlWithBase64Images(questionForm.form.questionHtml, 'questionHtml');
      if (processedHtml.isError) return processedHtml;
      questionForm.form.questionHtml = processedHtml;
    }
  
    if (questionForm.form.study) {
      const processedHtml = await processHtmlWithBase64Images(questionForm.form.study, 'study');
      if (processedHtml.isError) return processedHtml;
      questionForm.form.study = processedHtml;
    }
  
    // ✅ Step 3: Handle legacy image upload
    const storageRefPath = `images/questions/${revId}/${questionForm.subtopic}/${questionForm.form.id}`;
    if (questionForm.form.hasImage && imageFile) {
      const uploadRes = await uploadImage(storageRefPath, imageFile);
      if (uploadRes.isError) return uploadRes;
  
      questionForm.form.imageUrl = uploadRes.url;
      questionForm.form.storageRefPath = storageRefPath;
    }
  
    // ✅ Step 4: Delete legacy image if flagged
    if (!questionForm.form.hasImage && questionForm.form.storageRefPath) {
      await deleteImage(storageRefPath);
      questionForm.form.storageRefPath = '';
    }
  
    // ✅ Step 5: Call Cloud Function to update the question
    const updateQuestion = httpsCallable(functions, 'updateQuestion');
  
    try {
      const result = await updateQuestion({ ...questionForm, revId, tags });
  
        // ✅ Step 6: Background cleanup of outdated images
        (async () => {
            // Combine updated content from both fields
            const content = `${questionForm.form.questionHtml || ''}${questionForm.form.study || ''}`;
        
            // Normalize the content by stripping tokens from image srcs
            const cleanContent = content.replace(/(\?alt=media&token=[^"]*)/g, '');
        
            // Determine which URLs are no longer in the content
            const urlsToDelete = uploadImageUrls.filter(originalUrl => {
            const urlWithoutToken = originalUrl.split('?')[0];
            return !cleanContent.includes(urlWithoutToken);
            });
        
            for (const url of urlsToDelete) {
                try {
                    const decodedUrl = decodeURIComponent(url);
                    const match = decodedUrl.match(/\/o\/([^?]+)\?/); // extract path from URL
                    if (match && match[1]) {
                    const filePath = match[1];
                    await deleteImage(filePath);
                    
                    console.log(`Cleaned up unused image: ${filePath}`);
                    }
                } catch (err) {
                    console.warn(`Failed to delete image: ${url}`, err);
                }
            }
        })();      
  
      return result;
    } catch (err) {
      return {
        data: {
          isError: true,
          error: { message: 'Unexpected error occurred while updating the question.' }
        }
      };
    }
};
  

/**
 * Delete/remove subtopic from the questionnaire
 * @param {string} subtopic 
 * @returns 
 */
export const deleteSubtopicFromQuestionnaire = async(revId, subtopic) => {

    const deleteSubtopicFromQuestionnaire = httpsCallable(functions, 'deleteSubtopicFromQuestionnaire');
    // delete all images under this subtopic

    return await deleteSubtopicFromQuestionnaire({...subtopic, revId })
        .then((result) => {
            return result
        })
        .catch((err) => {
            return err;
        })
}

/**
 * Delete/remove question from subtopic list of questions
 * @param {number} qid 
 * @returns 
 */
// export const deleteQuestion = async(revId, data, storageRefPath, questionData) => {


//     // delete legacy image upload..
//     deleteImage(storageRefPath);

//     // delete all images upload thru the uploadBase64Image


//     const delQuestion = httpsCallable(functions, 'deleteQuestion');
//     return await delQuestion({...data, revId })
//         .then((result) => {
//             return result;
//         })
//         .catch((err) => {
//             console.log('Function deleteQuestion Error:', err)
//             return err;
//         })
// }
export const deleteQuestion = async (revId, data, storageRefPath, questionData) => {

    try {
      // ✅ Step 1: Delete legacy uploaded image if applicable
      if (storageRefPath) {
        await deleteImage(storageRefPath);
      }
  
      // ✅ Step 2: Gather all image src URLs from questionHtml and study
      const extractImageUrls = (html = '') => {
        const regex = /<img[^>]+src="([^">]+)"/g;
        const urls = [];
        let match;
        while ((match = regex.exec(html)) !== null) {
          urls.push(match[1]);
        }
        return urls;
      };
  
      const questionHtmlImages = extractImageUrls(questionData.questionHtml);
      const studyImages = extractImageUrls(questionData.study);
      const allImageUrls = [...questionHtmlImages, ...studyImages];
  
      // ✅ Step 3: Convert each URL to a Firebase Storage path and delete
      for (const url of allImageUrls) {
        try {
          // Decode the path from the URL
          const decodedUrl = decodeURIComponent(url);
          const match = decodedUrl.match(/\/o\/([^?]+)\?/); // e.g., images/questionsHtml/plus/corrosion/...
          if (match && match[1]) {
            const filePath = match[1]; // This is the full path in Storage
            // const fileRef = storageRef(storage, filePath);
            // await deleteObject(fileRef);
            await deleteImage(filePath);
            console.log(`Deleted: ${filePath}`);
          }
        } catch (err) {
          console.warn(`Could not delete image: ${url}`, err);
        }
      }
  
      // ✅ Step 4: Delete the Firestore document using your callable function
      const delQuestion = httpsCallable(functions, 'deleteQuestion');
      const result = await delQuestion({ ...data, revId });
  
      return result;
    } catch (err) {
      console.error('Error in deleteQuestion:', err);
      return {
        data: {
          isError: true,
          error: { message: 'Failed to delete question and associated images.' }
        }
      };
    }
  };

/**
 * upload image
 * Hard to implement using firebase cloud function
 * so for now, just implementing it here... ^____^
 * @param {*} questionForm 
 * @param {file} imageFile 
 * @returns 
 */
const uploadImage = async(storageRefPath, imageFile) => {

    if (imageFile) {

        const storageRef = ref(storage, storageRefPath);

        return await uploadBytes(storageRef, imageFile).then(async() => {
            return await getDownloadURL(storageRef).then((url) => {
                console.log('image url', url);
                return { isError: false, url: url };
            }).catch((e) => {
                console.log('unable to get the URL: ', e);
                return { isError: true, error: 'Upload error.' };
            });
        }).catch((e) => {
            console.log('Upload err: ', e);
            return { isError: true, error: 'Upload error.' };
        });
    }
    return { isError: true, error: 'file not found' };

}

/**
 * Uploads a base64 image string to Firebase Storage.
 * 
 * @param {string} storageRefPath - The storage path to upload the image to.
 * @param {string} base64String - The full base64 image string (e.g., "data:image/png;base64,...").
 * @returns {Promise<{ isError: boolean, url?: string, error?: string }>}
 */
const uploadBase64Image = async (storageRefPath, base64String) => {

    if (!base64String || typeof base64String !== 'string' || !base64String.startsWith('data:image/')) {
      return { isError: true, error: 'Invalid base64 image data.' };
    }
  
    try {

      const base64Data = base64String.split(',')[1];
      const mimeTypeMatch = base64String.match(/^data:(image\/[a-zA-Z]+);base64,/);
      if (!mimeTypeMatch) return { isError: true, error: 'Invalid MIME type.' };
  
      const mimeType = mimeTypeMatch[1];
  
      // Decode base64 to binary
      const byteChars = atob(base64Data);
      const byteNumbers = new Array(byteChars.length);
      for (let i = 0; i < byteChars.length; i++) {
        byteNumbers[i] = byteChars.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      const imageBlob = new Blob([byteArray], { type: mimeType });
  
      // Upload to Firebase Storage
      const storageRef = ref(storage, storageRefPath);
      await uploadBytes(storageRef, imageBlob);
      const url = await getDownloadURL(storageRef);
  
      return { isError: false, url };
  
    } catch (e) {
      console.error('uploadBase64Image error:', e);
      return { isError: true, error: 'Upload failed.' };
    }
  };

const deleteImage = async (storageRefPath) => {
    if (storageRefPath) {
        // Create a reference to the file to delete
        const toDelRef = ref(storage, storageRefPath);
        // Delete the file
        deleteObject(toDelRef);
    }
}